var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper pa-8"},[_c('EntitiesListTemplate',{attrs:{"items":_vm.users,"title":"Users","type":"user","full-height":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }